// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ user, loadingUser, children }) {
  // 1) Falls wir noch laden, nichts redirecten, sondern spinner.
  if (loadingUser) {
    return <div style={{ padding: '1rem' }}>Lade Benutzer-Daten…</div>;
  }
  // 2) Nach dem Laden: Wenn kein User -> redirect
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  // 3) Sonst Komponente darstellen
  return children;
}

export default ProtectedRoute;
